import React from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import moment from "moment";

import { ReportOperatorSalary } from "../../../models/ReportOperatorSalary";
import axiosClient from "../../../config/axios";

import OperatorSalaryForm from "../../../forms/OperatorSalaryForm";
import ReportOperatorSalarySchema from "../../../validations/ReportOperatorSalarySchema";
import TableOperatorSalary from "../../../components/reports/TableOperatorSalary";
import Loader from "../../../components/loader";
import OrderInvoiceForm from "../../../forms/OrderInvoiceForm";
import TableOrderInvoice from "../../../components/reports/TableOrderInvoice";
import OrderInsuranceForm from "../../../forms/OrderInsuranceForm";
import TableOrderInsurance from "../../../components/reports/TableOrderInsurance";

const OrderInsurance = () => {
  const [loading, setLoading] = React.useState(true);
  const [records, setRecords] = React.useState([]);
  const [orders, setOrders] = React.useState([]);

  const [insurances, setInsurances] = React.useState([]);
  const [insurance, setInsurance] = React.useState({label :"Todas las opciones",value : "all"});
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: ReportOperatorSalary(),
    validationSchema: ReportOperatorSalarySchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const adjustedStart = moment(values.start)
          .subtract(1, "days")
          .format("YYYY-MM-DD");
        const adjustedEnd = moment(values.end)
          .add(1, "days")
          .format("YYYY-MM-DD");

        // const endpoint = `/reports/operator-salary?start=${adjustedStart}&end=${adjustedEnd}`;
        const endpoint = `/reports/order-isurance?start=${values.start}&end=${values.end}&insuranceId=${insurance.value}`;
        const {data}  = await axiosClient.get(endpoint);

        //setRecords(data?.orders);
        //setOrders(data?.orders)
        setRecords(data);
        let dataTable = [];
        data?.ordenes?.map((record) => {
          const { insurance } = record;
          record.orders.map((order) => {
            dataTable.push({
              ...order,
              subtotal: order.orden_en_cero ? 0 : order.subtotal,
              insurance: insurance,
            });
          });
        });
        setOrders(dataTable);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    },
  });

  const fetchData = async () => {
    try {
        const response = await axiosClient.get('/insurers/all');
        
        const formattedOptions = [
            { value: "all", label: "Todas las opciones" }, 
            ...response.data.data.map(operator => ({
                value: operator.id,
                label: operator.insurance_name
            }))
        ];
        
        setInsurances(formattedOptions);
    } catch (error) {
        console.error(error);
    }
  };

  React.useEffect(() => {
    formik.handleSubmit(); // Esto podría generar efectos secundarios no deseados
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <Loader isLoading={loading} />
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item active">Reporte de ordenes por aseguradora</li>
          </ol>
          <h1 className="page-header mb-0">Reporte de ordenes por aseguradora</h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12 card border-0 p-3">
          <OrderInsuranceForm formik={formik} records={records} insurances={insurances} insurance={insurance} setInsurance={setInsurance}/>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12 card border-0 p-3">
          <TableOrderInsurance
            orders={orders}
            start={formik.values.start}
            end={formik.values.end}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default OrderInsurance;
